import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Typography from "./Typography";
import { isOrganizerAnalyticsUiEnabled } from "../config/analyticsFeatureFlags";

const MyEventsHeader = () => {
	const location = useLocation();
	const { t } = useTranslation("hostedEvents");

	return (
		<MyEventsHeaderWrapper>
			<Container>
				<Typography
					as="h1"
					$variant="title-4-semibold"
					$variantTablet="title-4-semibold"
					$variantMobile="body-1-semibold"
				>
					{t("header.title")}
				</Typography>
				<SectionTabs aria-label={t("header.tabs.label")}>
					<Link
						to="/hosted-events"
						aria-current={
							location.pathname === "/hosted-events" ? "page" : undefined
						}
						className={`SectionTab ${location.pathname === "/hosted-events" ? "Active" : ""}`}
					>
						<Typography
							as="span"
							$variant="body-1-semibold"
							$variantMobile="body-2-semibold"
						>
							{t("header.tabs.events")}
						</Typography>
					</Link>
					{/* <Link to="/hosted-events/enrolled" className={`SectionTab ${location.pathname === '/hosted-events/enrolled' ? 'Active' : ''}`}>
            <Typography as="span" $variant="body-1-semibold" $variantMobile="body-2-semibold">
              {t('header.tabs.enrolled')}
            </Typography>
          </Link> */}
					<Link
						to="/hosted-events/people"
						aria-current={
							location.pathname === "/hosted-events/people" ? "page" : undefined
						}
						className={`SectionTab ${location.pathname === "/hosted-events/people" ? "Active" : ""}`}
					>
						<Typography
							as="span"
							$variant="body-1-semibold"
							$variantMobile="body-2-semibold"
						>
							{t("header.tabs.people")}
						</Typography>
					</Link>
					{isOrganizerAnalyticsUiEnabled ? (
						<Link
							to="/hosted-events/statistics"
							aria-current={
								location.pathname === "/hosted-events/statistics"
									? "page"
									: undefined
							}
							className={`SectionTab ${location.pathname === "/hosted-events/statistics" ? "Active" : ""}`}
						>
							<Typography
								as="span"
								$variant="body-1-semibold"
								$variantMobile="body-2-semibold"
							>
								{t("header.tabs.statistics")}
							</Typography>
						</Link>
					) : null}
					<Link
						to="/hosted-events/settings"
						aria-current={
							location.pathname === "/hosted-events/settings"
								? "page"
								: undefined
						}
						className={`SectionTab ${location.pathname === "/hosted-events/settings" ? "Active" : ""}`}
					>
						<Typography
							as="span"
							$variant="body-1-semibold"
							$variantMobile="body-2-semibold"
						>
							{t("header.tabs.settings")}
						</Typography>
					</Link>
				</SectionTabs>
			</Container>
		</MyEventsHeaderWrapper>
	);
};

export default MyEventsHeader;

const MyEventsHeaderWrapper = styled.section`
  background-color: ${({ theme }) => theme.fill.defaultSubtle};
  align-items: center;
  display:flex;
  flex-direction: column;
  border-bottom: 1px solid ${({ theme }) => theme.border.defaultSubtle}; 

  .Tabs {
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.sizing.sm} ${({ theme }) => theme.sizing.md};
  padding-bottom: 0px;
  width: 100%;
  max-width: 1400px;
  gap: ${({ theme }) => theme.sizing.xs};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => theme.sizing.sm};
    padding-bottom: 0px;
    // gap: ${({ theme }) => theme.sizing.xs};
  }
`;

const SectionTabs = styled.nav`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.sizing.sm};
  max-width: 100%;
  overflow-x: auto;

  .SectionTab {
    display: flex;
    padding: 16px 0px;
    justify-content: center;
    align-items: flex-end;
    border: none;
    border-bottom: 4px solid transparent;
    background-color: transparent;
    text-decoration: none;
    
    span {
      color: var(--text-icon-default-subtle, #989898);
      transition: color 0.2s ease;
    }
  }

  .SectionTab.Active {
    border-bottom: 4px solid var(--border-brand-main, #F65703);
    
    span {
      color: var(--text-icon-brand-main, #F65703);
    }
  }
`;
